const WORDS_TO_NEXT = ['дальше', 'следующий', 'продолжить'];
const WORDS_TO_CONTROL = ['закрыть', 'к выбору темы', 'выйти', 'выход', 'темы'];

export { WORDS_TO_NEXT, WORDS_TO_CONTROL };
